import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import ClubTagList from './club-tag-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title='Club Tags'>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Running Clubs</Breadcrumb.Item>
            <Breadcrumb.Item active>Tags</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <ClubTagList />
    </Panel>
  );
};

export default Page;
